/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { number } from "io-ts"
import { UseFormWatch } from "react-hook-form"

import {
    TAmendHpDevicePostBody,
    THPDeviceResponseType,
    TPublishHpDevicePostBody,
    TSaveHpDeviceDraftPostBody,
} from "../../../../services/middleware/types/devices/lct/publishHpDeviceTypes"
import { HpDeviceFormData } from "../types/providerTypes"

export const HP_MANUFACTURER_REG = "hpManufacturer"
export const HP_MODEL_REG = "hpModel"
export const HP_MODEL_REF_REG = "hpModelRef"
export const HP_FUNCTION_REG = "hpFunction"
export const HP_TYPE_REG = "hpType"
export const HP_PHASES_REG = "hpPhases"
export const HP_VOLTAGE_REG = "hpVoltage"
export const HP_NOM_CURRENT_W35_REG = "hpNomCurrentW35"
export const HP_NOM_CURRENT_W45_REG = "hpNomCurrentW45"
export const HP_NOM_CURRENT_W55_REG = "hpNomCurrentW55"
export const HP_NOM_CURRENT_W65_REG = "hpNomCurrentW65"
export const HP_TOT_INPUT_RATED_CURRENT_REG = "hpTotInputRatedCurrent"
export const HP_TOT_INPUT_RATED_POWER_REG = "hpTotInputRatedPower"
export const HP_MAX_DEMAND_CURRENT_REG = "hpMaxDemandCurrent"
export const HP_MAX_DEMAND_POWER_REG = "hpMaxDemandPower"
export const HP_MODULE_REG = "hpModule"
export const HP_MODULE_REF_REG = "hpModuleRef"
export const HP_PRODUCT_CODE = "hpProductCode"
export const HP_HARMONIC_STANDARDS_REG = "hpHarmonicStandards"
export const HP_FLICKER_STANDARDS_REG = "hpFlickerStandards"
export const HP_BACK_UP_HEATER_PRESENT_REG = "hpBackUpHeaterPresent"
export const HP_BACK_UP_HEATER_PHASES_REG = "hpBackUpHeaterPhases"
export const HP_BACK_UP_HEATER_MODULE_REF_REG = "hpBackUpHeaterModuleRef"
export const HP_BACK_UP_HEATER_MODULE_REG = "hpBackUpHeaterModule"
export const HP_BACK_UP_HEATER_MODULE_INPUT_RATED_CURRENT_REG =
    "hpBackUpHeaterModuleInputRatedCurrent"
export const HP_BACK_UP_HEATER_MODULE_INPUT_RATED_POWER_REG =
    "hpBackUpHeaterModuleInputRatedPower"
export const HP_BOOST_HEATER_PRESENT_REG = "hpBoostHeaterPresent"
export const HP_BOOST_HEATER_PHASES_REG = "hpBoostHeaterPhases"
export const HP_BOOST_HEATER_MODULE_REF_REG = "hpBoostHeaterModuleRef"
export const HP_BOOST_HEATER_MODULE_REG = "hpBoostHeaterModule"
export const HP_BOOST_HEATER_MODULE_INPUT_RATED_CURRENT_REG =
    "hpBoostHeaterModuleInputRatedCurrent"
export const HP_BOOST_HEATER_MODULE_INPUT_RATED_POWER_REG =
    "hpBoostHeaterModuleInputRatedPower"
export const HP_WATER_HEATER_PRESENT_REG = "hpWaterHeaterPresent"
export const HP_WATER_HEATER_PHASES_REG = "hpWaterHeaterPhases"
export const HP_WATER_HEATER_MODULE_REF_REG = "hpWaterHeaterModuleRef"
export const HP_WATER_HEATER_MODULE_REG = "hpWaterHeaterModule"
export const HP_WATER_HEATER_MODULE_INPUT_RATED_CURRENT_REG =
    "hpWaterHeaterModuleInputRatedCurrent"
export const HP_WATER_HEATER_MODULE_INPUT_RATED_POWER_REG =
    "hpWaterHeaterModuleInputRatedPower"
export const HP_HEAT_PUMP_PRESENT_REG = "hpHeatPumpPresent"
export const HP_HEAT_PUMP_PHASES_REG = "hpHeatPumpPhases"
export const HP_HEAT_PUMP_MODULE_REF_REG = "hpHeatPumpModuleRef"
export const HP_HEAT_PUMP_MODULE_REG = "hpHeatPumpModule"
export const HP_HEAT_PUMP_MODULE_INPUT_RATED_CURRENT_REG =
    "hpHeatPumpModuleInputRatedCurrent"
export const HP_HEAT_PUMP_MODULE_INPUT_RATED_POWER_REG =
    "hpHeatPumpModuleInputRatedPower"

export const hpDeviceFormLabelMapping: { [key: string]: string } = {
    [HP_MANUFACTURER_REG]: "Manufacturer",
    [HP_MODEL_REG]: "Model",
    [HP_MODEL_REF_REG]: "Model Reference",
    [HP_FUNCTION_REG]: "Function",
    [HP_TYPE_REG]: "Heat Pump Type",
    [HP_PHASES_REG]: "Devices Phases",
    [HP_VOLTAGE_REG]: "Voltage",
    [HP_NOM_CURRENT_W35_REG]: "Nominal Current at A-7 / W35 (Amps per phase)",
    [HP_NOM_CURRENT_W45_REG]: "Nominal Current at A‑7 / W45 (Amps per phase)",
    [HP_NOM_CURRENT_W55_REG]: "Nominal Current at A‑7 / W55 (Amps per phase)",
    [HP_NOM_CURRENT_W65_REG]: "Nominal Current at A‑7 / W65 (Amps per phase)",
    [HP_TOT_INPUT_RATED_CURRENT_REG]:
        "Total Input Rated Current (Amps per phase)",
    [HP_TOT_INPUT_RATED_POWER_REG]: "Total Input Rated Power (kVA)",
    [HP_MAX_DEMAND_CURRENT_REG]: "Max Demand Current (Amps per phase)",
    [HP_MAX_DEMAND_POWER_REG]: "Max Demand Power (kVA)",
    [HP_MODULE_REG]: "Module",
    [HP_MODULE_REF_REG]: "Module Reference",
    [HP_PRODUCT_CODE]: "Product Code",
    [HP_HARMONIC_STANDARDS_REG]: "Harmonic Test Standards",
    [HP_FLICKER_STANDARDS_REG]: "Voltage Flicker Test Standards",
    [HP_BACK_UP_HEATER_PRESENT_REG]: "Is a Back-up Heater Present",
    [HP_BACK_UP_HEATER_PHASES_REG]: "Back-up Heater Phases",
    [HP_BACK_UP_HEATER_MODULE_REF_REG]: "Back-up Heater Module Reference",
    [HP_BACK_UP_HEATER_MODULE_REG]: "Back-up Heater Module",
    [HP_BACK_UP_HEATER_MODULE_INPUT_RATED_CURRENT_REG]:
        "Back-up Heater Module Input Rated Current (Amps per phase)",
    [HP_BACK_UP_HEATER_MODULE_INPUT_RATED_POWER_REG]:
        "Back-up Heater Module Input Rated Power (kVA)",
    [HP_BOOST_HEATER_PRESENT_REG]: "Is a Boost Heater Present",
    [HP_BOOST_HEATER_PHASES_REG]: "Boost Heater Phases",
    [HP_BOOST_HEATER_MODULE_REF_REG]: "Boost Heater Module Reference",
    [HP_BOOST_HEATER_MODULE_REG]: "Boost Heater Module",
    [HP_BOOST_HEATER_MODULE_INPUT_RATED_CURRENT_REG]:
        "Boost Heater Module Input Rated Current (Amps per phase)",
    [HP_BOOST_HEATER_MODULE_INPUT_RATED_POWER_REG]:
        "Boost Heater Module Input Rated Power (kVA)",
    [HP_WATER_HEATER_PRESENT_REG]: "Is a Water Heater Present",
    [HP_WATER_HEATER_PHASES_REG]: "Water Heater Phases",
    [HP_WATER_HEATER_MODULE_REF_REG]: "Water Heater Module Reference",
    [HP_WATER_HEATER_MODULE_REG]: "Water Heater Module",
    [HP_WATER_HEATER_MODULE_INPUT_RATED_CURRENT_REG]:
        "Water Heater Module Input Rated Current (Amps per phase)",
    [HP_WATER_HEATER_MODULE_INPUT_RATED_POWER_REG]:
        "Water Heater Module Input Rated Power (kVA)",
    [HP_HEAT_PUMP_PRESENT_REG]: "Is a Back-up Heat Pump Present?",
    [HP_HEAT_PUMP_PHASES_REG]: "Back-Up Heat Pump Phases",
    [HP_HEAT_PUMP_MODULE_REF_REG]: "Back-Up Heat Pump Module Reference",
    [HP_HEAT_PUMP_MODULE_REG]: "Back-Up Heat Pump Module",
    [HP_HEAT_PUMP_MODULE_INPUT_RATED_CURRENT_REG]:
        "Back-Up Heat Pump Module Input Rated Current (Amps per phase)",
    [HP_HEAT_PUMP_MODULE_INPUT_RATED_POWER_REG]:
        "Back-Up Heat Pump Module Input Rated Power (kVA)",
}

export const NON_SYS_ADMIN_HP_STEPS = [
    "Core Heat Pump Device Details",
    "Upload Supporting Files",
    "Review and Submit",
]
export const NON_SYS_ADMIN_HP_STEPS_AMEND = [
    "Amend Core Heat Pump Device Details",
    "Amend Supporting Files",
    "Review and Submit Amendment",
]

export const HP_FUNCTIONS = ["Heating Only", "Heating and Cooling"]
export const HP_TYPES = ["Air Source", "Ground Source", "Water Source"]
export const HP_MODULE_OPTIONS = [
    "Heat Pump",
    "Heat pump+Back-up heater",
    "Heat pump+Back-up heater - external",
    "Heat pump+Back-up heater - on-board",
    "Heat pump+Back-up heater - on-board+Water (immersion) heater - on-board",
    "Heat pump+Back-up heater+Boost heater",
    "Heat pump+Boost heater",
    "Heat pump+Heat pump",
    "Heat pump+Heat pump+Back-up heater - on-board",
    "Heat pump+Heat pump+Back-up heater - on-board+Water (immersion) heater - on-board",
    "Heat pump+Supplementary (boost) heater - external",
    "Heat pump+Supplementary (boost) heater - on-board",
    "Heat pump+Water (immersion) heater - external",
    "Whole system",
]

export const HP_BOOST_HEATER_MODULE_OPTIONS = [
    "Boost heater",
    "Supplementary (boost) heater - external",
    "Supplementary (boost) heater - on-board",
]
export const HP_HEAT_PUMP_MODULE_OPTIONS = ["Heat pump"]
export const HP_WATER_HEATER_MODULE_OPTIONS = [
    "Water (immersion) heater - external",
    "Water (immersion) heater - on-board",
]
export const HP_BACK_UP_HEATER_MODULE_OPTIONS = [
    "Back-up heater",
    "Back-up heater - external",
    "Back-up heater - on-board",
]

export const HP_HARMONIC_TEST_STANDARDS = {
    "EN 61000-3-12": "EN 61000-3-12",
    "EN 61000-3-2": "EN 61000-3-2",
    "EN 61000-6-3": "EN 61000-6-3",
    "EN 61000-6-4": "EN 61000-6-4",
    "N/A": "N/A",
}

export const HP_FLICKER_TEST_STANDARDS = {
    "EN 61000-3-11": "EN 61000-3-11",
    "EN 61000-3-3": "EN 61000-3-3",
    "EN 61000-6-3": "EN 61000-6-3",
    "EN 61000-6-4": "EN 61000-6-4",
    "N/A": "N/A",
}

export const IS_MODULE_PRESENT = "TRUE"
export const IS_MODULE_NOT_PRESENT = "FALSE"
export const IS_MODULE_PRESENT_OPTIONS = {
    Yes: IS_MODULE_PRESENT,
    No: IS_MODULE_NOT_PRESENT,
}

/**
 * Returns HP Device form data where all fields are empty.
 *
 * Note: Avoid using `undefined` when providing a default value
 */
export const getEmptyHpDeviceFormData = (): HpDeviceFormData => ({
    manufacturerId: null,
    deviceMake: "",
    deviceModel: "",
    deviceModelRef: "",
    function: null,
    heatPumpType: null,
    devicePhases: null,
    deviceVoltage: null,
    deviceNomCurrentW35: null,
    deviceNomCurrentW45: null,
    deviceNomCurrentW55: null,
    deviceNomCurrentW65: null,
    deviceTotInputRatedCurrent: null,
    deviceTotInputRatedPower: null,
    deviceMaxDemandCurrent: null,
    deviceMaxDemandPower: null,
    deviceModule: null,
    deviceModuleRef: "",
    deviceProductCode: "",
    deviceHarmonicStandards: null,
    deviceFlickerStandards: null,
    deviceIsBackUpHeaterPresent: null,
    deviceBackUpHeaterPhases: null,
    deviceBackUpHeaterModuleRef: "",
    deviceBackUpHeaterModule: null,
    deviceBackUpHeaterModuleInputRatedCurrent: null,
    deviceBackUpHeaterModuleInputRatedPower: null,
    deviceIsBoostHeaterPresent: null,
    deviceBoostHeaterPhases: null,
    deviceBoostHeaterModuleRef: "",
    deviceBoostHeaterModule: null,
    deviceBoostHeaterModuleInputRatedCurrent: null,
    deviceBoostHeaterModuleInputRatedPower: null,
    deviceIsWaterHeaterPresent: null,
    deviceWaterHeaterPhases: null,
    deviceWaterHeaterModuleRef: "",
    deviceWaterHeaterModule: null,
    deviceWaterHeaterModuleInputRatedCurrent: null,
    deviceWaterHeaterModuleInputRatedPower: null,
    deviceIsHeatPumpModulePresent: null,
    deviceHeatPumpModulePhases: null,
    deviceHeatPumpModuleRef: "",
    deviceHeatPumpModule: null,
    deviceHeatPumpModuleInputRatedCurrent: null,
    deviceHeatPumpModuleInputRatedPower: null,
    stagedAttachments: [],
    systemReference: null,
})

/** Parses form register from form data for HP */
export const mapHpRegisterNameToValues = (
    formData: HpDeviceFormData
): { [name: string]: NonNullable<unknown> | undefined | null } => ({
    [HP_MANUFACTURER_REG]: formData.manufacturerId,
    [HP_MODEL_REG]: formData.deviceModel,
    [HP_MODEL_REF_REG]: formData.deviceModelRef,
    [HP_FUNCTION_REG]: formData.function,
    [HP_TYPE_REG]: formData.heatPumpType,
    [HP_PHASES_REG]: formData.devicePhases,
    [HP_VOLTAGE_REG]: formData.deviceVoltage,
    [HP_NOM_CURRENT_W35_REG]: formData.deviceNomCurrentW35,
    [HP_NOM_CURRENT_W45_REG]: formData.deviceNomCurrentW45,
    [HP_NOM_CURRENT_W55_REG]: formData.deviceNomCurrentW55,
    [HP_NOM_CURRENT_W65_REG]: formData.deviceNomCurrentW65,
    [HP_TOT_INPUT_RATED_CURRENT_REG]: formData.deviceTotInputRatedCurrent,
    [HP_TOT_INPUT_RATED_POWER_REG]: formData.deviceTotInputRatedPower,
    [HP_MAX_DEMAND_CURRENT_REG]: formData.deviceMaxDemandCurrent,
    [HP_MAX_DEMAND_POWER_REG]: formData.deviceMaxDemandPower,
    [HP_MODULE_REG]: formData.deviceModule,
    [HP_MODULE_REF_REG]: formData.deviceModuleRef,
    [HP_PRODUCT_CODE]: formData.deviceProductCode,
    [HP_HARMONIC_STANDARDS_REG]: formData.deviceHarmonicStandards,
    [HP_FLICKER_STANDARDS_REG]: formData.deviceFlickerStandards,
    [HP_BACK_UP_HEATER_PRESENT_REG]: formData.deviceIsBackUpHeaterPresent,
    [HP_BACK_UP_HEATER_PHASES_REG]: formData.deviceBackUpHeaterPhases,
    [HP_BACK_UP_HEATER_MODULE_REF_REG]: formData.deviceBackUpHeaterModuleRef,
    [HP_BACK_UP_HEATER_MODULE_REG]: formData.deviceBackUpHeaterModule,
    [HP_BACK_UP_HEATER_MODULE_INPUT_RATED_CURRENT_REG]:
        formData.deviceBackUpHeaterModuleInputRatedCurrent,
    [HP_BACK_UP_HEATER_MODULE_INPUT_RATED_POWER_REG]:
        formData.deviceBackUpHeaterModuleInputRatedPower,
    [HP_BOOST_HEATER_PRESENT_REG]: formData.deviceIsBoostHeaterPresent,
    [HP_BOOST_HEATER_PHASES_REG]: formData.deviceBoostHeaterPhases,
    [HP_BOOST_HEATER_MODULE_REF_REG]: formData.deviceBoostHeaterModuleRef,
    [HP_BOOST_HEATER_MODULE_REG]: formData.deviceBoostHeaterModule,
    [HP_BOOST_HEATER_MODULE_INPUT_RATED_CURRENT_REG]:
        formData.deviceBoostHeaterModuleInputRatedCurrent,
    [HP_BOOST_HEATER_MODULE_INPUT_RATED_POWER_REG]:
        formData.deviceBoostHeaterModuleInputRatedPower,
    [HP_WATER_HEATER_PRESENT_REG]: formData.deviceIsWaterHeaterPresent,
    [HP_WATER_HEATER_PHASES_REG]: formData.deviceWaterHeaterPhases,
    [HP_WATER_HEATER_MODULE_REF_REG]: formData.deviceWaterHeaterModuleRef,
    [HP_WATER_HEATER_MODULE_REG]: formData.deviceWaterHeaterModule,
    [HP_WATER_HEATER_MODULE_INPUT_RATED_CURRENT_REG]:
        formData.deviceWaterHeaterModuleInputRatedCurrent,
    [HP_WATER_HEATER_MODULE_INPUT_RATED_POWER_REG]:
        formData.deviceWaterHeaterModuleInputRatedPower,
    [HP_HEAT_PUMP_PRESENT_REG]: formData.deviceIsHeatPumpModulePresent,
    [HP_HEAT_PUMP_PHASES_REG]: formData.deviceHeatPumpModulePhases,
    [HP_HEAT_PUMP_MODULE_REF_REG]: formData.deviceHeatPumpModuleRef,
    [HP_HEAT_PUMP_MODULE_REG]: formData.deviceHeatPumpModule,
    [HP_HEAT_PUMP_MODULE_INPUT_RATED_CURRENT_REG]:
        formData.deviceHeatPumpModuleInputRatedCurrent,
    [HP_HEAT_PUMP_MODULE_INPUT_RATED_POWER_REG]:
        formData.deviceHeatPumpModuleInputRatedPower,
})

/**
 * Generates create HP post body from form data
 * @param {HpDeviceFormData} formData - data input from the form
 * @param {string} attachmentUUID - device attachment UUID
 * @returns {TPublishHpDevicePostBody} - the post body for the publish LCT device request
 */
export const createHpPostBodyFromData = (
    formData: HpDeviceFormData,
    attachmentUUID: string,
    systemReference?: string
): TPublishHpDevicePostBody => ({
    device_type: "HP",
    device_data: {
        LCTDeviceType: "HP",
        ManufacturerID: formData.manufacturerId ?? undefined,
        Make: formData.deviceMake,
        Model: formData.deviceModel,
        ModelReference: formData.deviceModelRef,
        Function: formData.function as string,
        HeatPumpType: formData.heatPumpType as string,
        Phases: formData.devicePhases! ?? undefined,
        Voltage: formData.deviceVoltage! ?? number,
        NominalCurrent_A7_W35: formData.deviceNomCurrentW35! ?? undefined,
        NominalCurrent_A7_W45: formData.deviceNomCurrentW45! ?? undefined,
        NominalCurrent_A7_W55: formData.deviceNomCurrentW55! ?? undefined,
        NominalCurrent_A7_W65: formData.deviceNomCurrentW65! ?? undefined,
        TotalHPSysInputRatedCurrent:
            formData.deviceTotInputRatedCurrent! ?? undefined,
        TotalHPSysInputRatedPower:
            formData.deviceTotInputRatedPower! ?? undefined,
        TotalHPSysMaxDemandCurrent:
            formData.deviceMaxDemandCurrent! ?? undefined,
        TotalHPSysMaxDemandPower: formData.deviceMaxDemandPower! ?? undefined,
        Module: formData.deviceModule! ?? undefined,
        ModuleReference: formData.deviceModuleRef,
        ProductCode: formData.deviceProductCode,
        HarmonicStandards: formData.deviceHarmonicStandards! ?? undefined,
        VoltageFluctuationFlickerStandards:
            formData.deviceFlickerStandards! ?? undefined,
        BackUpHeater_Status: formData.deviceIsBackUpHeaterPresent! ?? undefined,
        BackUpHeater_Phases: formData.deviceBackUpHeaterPhases! ?? undefined,
        BackUpHeater_ModuleReference: formData.deviceBackUpHeaterModuleRef,
        BackUpHeater_Module: formData.deviceBackUpHeaterModule! ?? undefined,
        BackUpHeater_ModuleInputRatedCurrent:
            formData.deviceBackUpHeaterModuleInputRatedCurrent! ?? undefined,
        BackUpHeater_ModuleInputRatedPower:
            formData.deviceBackUpHeaterModuleInputRatedPower! ?? undefined,
        BoostHeater_Status: formData.deviceIsBoostHeaterPresent! ?? undefined,
        BoostHeater_Phases: formData.deviceBoostHeaterPhases! ?? undefined,
        BoostHeater_ModuleReference: formData.deviceBoostHeaterModuleRef,
        BoostHeater_Module: formData.deviceBoostHeaterModule! ?? undefined,
        BoostHeater_ModuleInputRatedCurrent:
            formData.deviceBoostHeaterModuleInputRatedCurrent! ?? undefined,
        BoostHeater_ModuleInputRatedPower:
            formData.deviceBoostHeaterModuleInputRatedPower! ?? undefined,
        WaterHeater_Status: formData.deviceIsWaterHeaterPresent! ?? undefined,
        WaterHeater_Phases: formData.deviceWaterHeaterPhases! ?? undefined,
        WaterHeater_ModuleReference: formData.deviceWaterHeaterModuleRef,
        WaterHeater_Module: formData.deviceWaterHeaterModule! ?? undefined,
        WaterHeater_ModuleInputRatedCurrent:
            formData.deviceWaterHeaterModuleInputRatedCurrent! ?? undefined,
        WaterHeater_ModuleInputRatedPower:
            formData.deviceWaterHeaterModuleInputRatedPower! ?? undefined,
        HeatPump_Status: formData.deviceIsHeatPumpModulePresent! ?? undefined,
        HeatPump_Phases: formData.deviceHeatPumpModulePhases! ?? undefined,
        HeatPump_ModuleReference: formData.deviceHeatPumpModuleRef,
        HeatPump_Module: formData.deviceHeatPumpModule! ?? undefined,
        HeatPump_ModuleInputRatedCurrent:
            formData.deviceHeatPumpModuleInputRatedCurrent! ?? undefined,
        HeatPump_ModuleInputRatedPower:
            formData.deviceHeatPumpModuleInputRatedPower! ?? undefined,

        Attachment_UUID: attachmentUUID,
        SystemReference: systemReference,
    },
})

/** Gets updated Hp form data.
 *
 * @param formData - The form data
 * @param watch - The watch function from react-hook-form
 * @returns The updated form data
 */
export const getHpUpdatedFormData = (
    formData: HpDeviceFormData,
    watch: UseFormWatch<Record<string, unknown>>
): HpDeviceFormData => ({
    ...formData,
    deviceModel: watch(HP_MODEL_REG) as string,
    deviceModelRef: watch(HP_MODEL_REF_REG) as string,
    function: watch(HP_FUNCTION_REG) as string,
    heatPumpType: watch(HP_TYPE_REG) as string,
    devicePhases: watch(HP_PHASES_REG) as number,
    deviceVoltage: watch(HP_VOLTAGE_REG) as number,
    deviceNomCurrentW35: watch(HP_NOM_CURRENT_W35_REG) as number,
    deviceNomCurrentW45: watch(HP_NOM_CURRENT_W45_REG) as number,
    deviceNomCurrentW55: watch(HP_NOM_CURRENT_W55_REG) as number,
    deviceNomCurrentW65: watch(HP_NOM_CURRENT_W65_REG) as number,
    deviceTotInputRatedCurrent: watch(HP_TOT_INPUT_RATED_CURRENT_REG) as number,
    deviceTotInputRatedPower: watch(HP_TOT_INPUT_RATED_POWER_REG) as number,
    deviceMaxDemandCurrent: watch(HP_MAX_DEMAND_CURRENT_REG) as number,
    deviceMaxDemandPower: watch(HP_MAX_DEMAND_POWER_REG) as number,
    deviceModule: watch(HP_MODULE_REG) as string,
    deviceModuleRef: watch(HP_MODULE_REF_REG) as string,
    deviceProductCode: watch(HP_PRODUCT_CODE) as string,
    deviceHarmonicStandards: watch(HP_HARMONIC_STANDARDS_REG) as string,
    deviceFlickerStandards: watch(HP_FLICKER_STANDARDS_REG) as string,
    deviceIsBackUpHeaterPresent: watch(HP_BACK_UP_HEATER_PRESENT_REG) as string,
    deviceBackUpHeaterPhases: watch(HP_BACK_UP_HEATER_PHASES_REG) as number,
    deviceBackUpHeaterModuleRef: watch(
        HP_BACK_UP_HEATER_MODULE_REF_REG
    ) as string,
    deviceBackUpHeaterModule: watch(HP_BACK_UP_HEATER_MODULE_REG) as string,
    deviceBackUpHeaterModuleInputRatedCurrent: watch(
        HP_BACK_UP_HEATER_MODULE_INPUT_RATED_CURRENT_REG
    ) as number,
    deviceBackUpHeaterModuleInputRatedPower: watch(
        HP_BACK_UP_HEATER_MODULE_INPUT_RATED_POWER_REG
    ) as number,
    deviceIsBoostHeaterPresent: watch(HP_BOOST_HEATER_PRESENT_REG) as string,
    deviceBoostHeaterPhases: watch(HP_BOOST_HEATER_PHASES_REG) as number,
    deviceBoostHeaterModuleRef: watch(HP_BOOST_HEATER_MODULE_REF_REG) as string,
    deviceBoostHeaterModule: watch(HP_BOOST_HEATER_MODULE_REG) as string,
    deviceBoostHeaterModuleInputRatedCurrent: watch(
        HP_BOOST_HEATER_MODULE_INPUT_RATED_CURRENT_REG
    ) as number,
    deviceBoostHeaterModuleInputRatedPower: watch(
        HP_BOOST_HEATER_MODULE_INPUT_RATED_POWER_REG
    ) as number,
    deviceIsWaterHeaterPresent: watch(HP_WATER_HEATER_PRESENT_REG) as string,
    deviceWaterHeaterPhases: watch(HP_WATER_HEATER_PHASES_REG) as number,
    deviceWaterHeaterModuleRef: watch(HP_WATER_HEATER_MODULE_REF_REG) as string,
    deviceWaterHeaterModule: watch(HP_WATER_HEATER_MODULE_REG) as string,
    deviceWaterHeaterModuleInputRatedCurrent: watch(
        HP_WATER_HEATER_MODULE_INPUT_RATED_CURRENT_REG
    ) as number,
    deviceWaterHeaterModuleInputRatedPower: watch(
        HP_WATER_HEATER_MODULE_INPUT_RATED_POWER_REG
    ) as number,
    deviceIsHeatPumpModulePresent: watch(HP_HEAT_PUMP_PRESENT_REG) as string,
    deviceHeatPumpModulePhases: watch(HP_HEAT_PUMP_PHASES_REG) as number,
    deviceHeatPumpModuleRef: watch(HP_HEAT_PUMP_MODULE_REF_REG) as string,
    deviceHeatPumpModule: watch(HP_HEAT_PUMP_MODULE_REG) as string,
    deviceHeatPumpModuleInputRatedCurrent: watch(
        HP_HEAT_PUMP_MODULE_INPUT_RATED_CURRENT_REG
    ) as number,
    deviceHeatPumpModuleInputRatedPower: watch(
        HP_HEAT_PUMP_MODULE_INPUT_RATED_POWER_REG
    ) as number,
})

/**
 * Generates amend HP post body from form data
 * @param {HpDeviceFormData} formData - data input from the form
 * @param {string} attachmentUUID - device attachment UUID
 * @returns {TPublishEvdcDevicePostBody} - the post body for the publish LCT device request
 */
// TODO - add in assessment fields
export const amendHpPostBodyFromData = (
    formData: HpDeviceFormData,
    attachmentUUID: string,
    systemReference: string
): TAmendHpDevicePostBody => ({
    device_type: "HP",
    device_data: {
        LCTDeviceType: "HP",
        ManufacturerID: formData.manufacturerId ?? undefined,
        Model: formData.deviceModel,
        Make: formData.deviceMake,
        ModelReference: formData.deviceModelRef,
        Function: formData.function as string,
        HeatPumpType: formData.heatPumpType as string,
        Phases: formData.devicePhases! as number,
        Voltage: formData.deviceVoltage! as number,
        NominalCurrent_A7_W35: formData.deviceNomCurrentW35 ?? undefined,
        NominalCurrent_A7_W45: formData.deviceNomCurrentW45 ?? undefined,
        NominalCurrent_A7_W55: formData.deviceNomCurrentW55 ?? undefined,
        NominalCurrent_A7_W65: formData.deviceNomCurrentW65 ?? undefined,
        TotalHPSysInputRatedCurrent:
            formData.deviceTotInputRatedCurrent! as number,
        TotalHPSysInputRatedPower: formData.deviceTotInputRatedPower! as number,
        TotalHPSysMaxDemandCurrent: formData.deviceMaxDemandCurrent! as number,
        TotalHPSysMaxDemandPower: formData.deviceMaxDemandPower! as number,
        Module: formData.deviceModule as string,
        ModuleReference: formData.deviceModuleRef,
        ProductCode: formData.deviceProductCode,
        HarmonicStandards: formData.deviceHarmonicStandards as string,
        VoltageFluctuationFlickerStandards:
            formData.deviceFlickerStandards as string,
        BackUpHeater_Status: formData.deviceIsBackUpHeaterPresent as string,
        BackUpHeater_Phases: formData.deviceBackUpHeaterPhases ?? undefined,
        BackUpHeater_ModuleReference: formData.deviceBackUpHeaterModuleRef,
        BackUpHeater_Module: formData.deviceBackUpHeaterModule as string,
        BackUpHeater_ModuleInputRatedCurrent:
            formData.deviceBackUpHeaterModuleInputRatedCurrent ?? undefined,
        BackUpHeater_ModuleInputRatedPower:
            formData.deviceBackUpHeaterModuleInputRatedPower ?? undefined,
        BoostHeater_Status: formData.deviceIsBoostHeaterPresent as string,
        BoostHeater_Phases: formData.deviceBoostHeaterPhases ?? undefined,
        BoostHeater_ModuleReference: formData.deviceBoostHeaterModuleRef,
        BoostHeater_Module: formData.deviceBoostHeaterModule as string,
        BoostHeater_ModuleInputRatedCurrent:
            formData.deviceBoostHeaterModuleInputRatedCurrent ?? undefined,
        BoostHeater_ModuleInputRatedPower:
            formData.deviceBoostHeaterModuleInputRatedPower ?? undefined,
        WaterHeater_Status: formData.deviceIsWaterHeaterPresent as string,
        WaterHeater_Phases: formData.deviceWaterHeaterPhases ?? undefined,
        WaterHeater_ModuleReference: formData.deviceWaterHeaterModuleRef,
        WaterHeater_Module: formData.deviceWaterHeaterModule as string,
        WaterHeater_ModuleInputRatedCurrent:
            formData.deviceWaterHeaterModuleInputRatedCurrent ?? undefined,
        WaterHeater_ModuleInputRatedPower:
            formData.deviceWaterHeaterModuleInputRatedPower ?? undefined,
        HeatPump_Status: formData.deviceIsHeatPumpModulePresent as string,
        HeatPump_Phases: formData.deviceHeatPumpModulePhases ?? undefined,
        HeatPump_ModuleReference: formData.deviceHeatPumpModuleRef,
        HeatPump_Module: formData.deviceHeatPumpModule as string,
        HeatPump_ModuleInputRatedCurrent:
            formData.deviceHeatPumpModuleInputRatedCurrent ?? undefined,
        HeatPump_ModuleInputRatedPower:
            formData.deviceHeatPumpModuleInputRatedPower ?? undefined,
        SystemReference: systemReference,
        Attachment_UUID: attachmentUUID,
    },
})

/**
 *  Maps the device responses from API endpoints to Device form data for amendments
 * @param {THPDeviceResponseType} output - the response from the API
 * @returns {HpDeviceFormData} - the form data for the Hp device
 */
export const mapHpDeviceResponseToDeviceFormData = <
    T extends THPDeviceResponseType,
>(
    output?: T
): HpDeviceFormData => {
    if (!output) {
        return getEmptyHpDeviceFormData()
    }

    return {
        manufacturerId: output.ManufacturerID,
        deviceMake: output.Make ?? "",
        deviceModel: output.Model ?? "",
        deviceModelRef: output.ModelReference ?? "",
        function: output.Function,
        heatPumpType: output.HeatPumpType,
        devicePhases: output.Phases,
        deviceVoltage: output.Voltage,
        deviceNomCurrentW35: output.NominalCurrent_A7_W35,
        deviceNomCurrentW45: output.NominalCurrent_A7_W45,
        deviceNomCurrentW55: output.NominalCurrent_A7_W55,
        deviceNomCurrentW65: output.NominalCurrent_A7_W65,
        deviceTotInputRatedCurrent: output.TotalHPSysInputRatedCurrent,
        deviceTotInputRatedPower: output.TotalHPSysInputRatedPower,
        deviceMaxDemandCurrent: output.TotalHPSysMaxDemandCurrent,
        deviceMaxDemandPower: output.TotalHPSysMaxDemandPower,
        deviceModule: output.Module,
        deviceModuleRef: output.ModuleReference ?? "",
        deviceProductCode: output.ProductCode ?? "",
        deviceHarmonicStandards: output.HarmonicStandards,
        deviceFlickerStandards: output.VoltageFluctuationFlickerStandards,
        deviceIsBackUpHeaterPresent: output.BackUpHeater_Status,
        deviceBackUpHeaterPhases: output.BackUpHeater_Phases,
        deviceBackUpHeaterModuleRef: output.BackUpHeater_ModuleReference ?? "",
        deviceBackUpHeaterModule: output.BackUpHeater_Module,
        deviceBackUpHeaterModuleInputRatedCurrent:
            output.BackUpHeater_ModuleInputRatedCurrent,
        deviceBackUpHeaterModuleInputRatedPower:
            output.BackUpHeater_ModuleInputRatedPower,
        deviceIsBoostHeaterPresent: output.BoostHeater_Status,
        deviceBoostHeaterPhases: output.BoostHeater_Phases,
        deviceBoostHeaterModuleRef: output.BoostHeater_ModuleReference ?? "",
        deviceBoostHeaterModule: output.BoostHeater_Module,
        deviceBoostHeaterModuleInputRatedCurrent:
            output.BoostHeater_ModuleInputRatedCurrent,
        deviceBoostHeaterModuleInputRatedPower:
            output.BoostHeater_ModuleInputRatedPower,
        deviceIsWaterHeaterPresent: output.WaterHeater_Status,
        deviceWaterHeaterPhases: output.WaterHeater_Phases,
        deviceWaterHeaterModuleRef: output.WaterHeater_ModuleReference ?? "",
        deviceWaterHeaterModule: output.WaterHeater_Module,
        deviceWaterHeaterModuleInputRatedCurrent:
            output.WaterHeater_ModuleInputRatedCurrent,
        deviceWaterHeaterModuleInputRatedPower:
            output.WaterHeater_ModuleInputRatedPower,
        deviceIsHeatPumpModulePresent: output.HeatPump_Status,
        deviceHeatPumpModulePhases: output.HeatPump_Phases,
        deviceHeatPumpModuleRef: output.HeatPump_ModuleReference ?? "",
        deviceHeatPumpModule: output.HeatPump_Module,
        deviceHeatPumpModuleInputRatedCurrent:
            output.HeatPump_ModuleInputRatedCurrent,
        deviceHeatPumpModuleInputRatedPower:
            output.HeatPump_ModuleInputRatedPower,
        stagedAttachments: [],
        systemReference: output.SystemReference,
    }
}

export const createHpDeviceDraftPostBody = (
    formData: HpDeviceFormData,
    attachmentUUID: string,
    isAmendment: boolean,
    systemReference?: string
): TSaveHpDeviceDraftPostBody => ({
    device_type: "HP",
    device_data: {
        LCTDeviceType: "HP",
        ManufacturerID: formData.manufacturerId ?? undefined,
        Model: formData.deviceModel,
        Make: formData.deviceMake,
        ModelReference: formData.deviceModelRef,
        Function: formData.function as string,
        HeatPumpType: formData.heatPumpType as string,
        Phases: formData.devicePhases! as number,
        Voltage: formData.deviceVoltage! as number,
        NominalCurrent_A7_W35: formData.deviceNomCurrentW35 ?? undefined,
        NominalCurrent_A7_W45: formData.deviceNomCurrentW45 ?? undefined,
        NominalCurrent_A7_W55: formData.deviceNomCurrentW55 ?? undefined,
        NominalCurrent_A7_W65: formData.deviceNomCurrentW65 ?? undefined,
        TotalHPSysInputRatedCurrent:
            formData.deviceTotInputRatedCurrent! as number,
        TotalHPSysInputRatedPower: formData.deviceTotInputRatedPower! as number,
        TotalHPSysMaxDemandCurrent: formData.deviceMaxDemandCurrent! as number,
        TotalHPSysMaxDemandPower: formData.deviceMaxDemandPower! as number,
        Module: formData.deviceModule as string,
        ModuleReference: formData.deviceModuleRef,
        ProductCode: formData.deviceProductCode,
        HarmonicStandards: formData.deviceHarmonicStandards as string,
        VoltageFluctuationFlickerStandards:
            formData.deviceFlickerStandards as string,
        BackUpHeater_Status: formData.deviceIsBackUpHeaterPresent as string,
        BackUpHeater_Phases: formData.deviceBackUpHeaterPhases ?? undefined,
        BackUpHeater_ModuleReference: formData.deviceBackUpHeaterModuleRef,
        BackUpHeater_Module: formData.deviceBackUpHeaterModule as string,
        BackUpHeater_ModuleInputRatedCurrent:
            formData.deviceBackUpHeaterModuleInputRatedCurrent ?? undefined,
        BackUpHeater_ModuleInputRatedPower:
            formData.deviceBackUpHeaterModuleInputRatedPower ?? undefined,
        BoostHeater_Status: formData.deviceIsBoostHeaterPresent as string,
        BoostHeater_Phases: formData.deviceBoostHeaterPhases ?? undefined,
        BoostHeater_ModuleReference: formData.deviceBoostHeaterModuleRef,
        BoostHeater_Module: formData.deviceBoostHeaterModule as string,
        BoostHeater_ModuleInputRatedCurrent:
            formData.deviceBoostHeaterModuleInputRatedCurrent ?? undefined,
        BoostHeater_ModuleInputRatedPower:
            formData.deviceBoostHeaterModuleInputRatedPower ?? undefined,
        WaterHeater_Status: formData.deviceIsWaterHeaterPresent as string,
        WaterHeater_Phases: formData.deviceWaterHeaterPhases ?? undefined,
        WaterHeater_ModuleReference: formData.deviceWaterHeaterModuleRef,
        WaterHeater_Module: formData.deviceWaterHeaterModule as string,
        WaterHeater_ModuleInputRatedCurrent:
            formData.deviceWaterHeaterModuleInputRatedCurrent ?? undefined,
        WaterHeater_ModuleInputRatedPower:
            formData.deviceWaterHeaterModuleInputRatedPower ?? undefined,
        HeatPump_Status: formData.deviceIsHeatPumpModulePresent as string,
        HeatPump_Phases: formData.deviceHeatPumpModulePhases ?? undefined,
        HeatPump_ModuleReference: formData.deviceHeatPumpModuleRef,
        HeatPump_Module: formData.deviceHeatPumpModule as string,
        HeatPump_ModuleInputRatedCurrent:
            formData.deviceHeatPumpModuleInputRatedCurrent ?? undefined,
        HeatPump_ModuleInputRatedPower:
            formData.deviceHeatPumpModuleInputRatedPower ?? undefined,
        SystemReference: systemReference,
        Attachment_UUID: attachmentUUID,
    },
    is_amendment: isAmendment,
})
